import React from 'react';
import PropTypes from 'prop-types';
import { Page, Text, View, Document, StyleSheet, Font } from '@react-pdf/renderer';
import regularFont from '../../assets/fonts/Metropolis-Regular.ttf';
import boldFont from '../../assets/fonts/Metropolis-SemiBold.ttf';
import ITEM_TEMPERATURE from '../../components/constants/itemTemperature';

const AdminDeliveryDayViewDeliveriesPdfDocument = ({
  deliveryOrderBatches,
  courierName,
  totalFruits,
  totalVegs,
  routeId,
  copy,
}) => {
  const BORDER_COLOR = '#000';
  const BORDER_STYLE = 'solid';

  Font.register({
    family: 'metropolis',
    fonts: [{ src: regularFont }, { src: boldFont, fontWeight: 600 }],
  });

  // disable hyphenation
  Font.registerHyphenationCallback((word) => [word]);

  const styles = StyleSheet.create({
    body: {
      padding: 5,
      fontSize: 12,
      fontFamily: 'metropolis',
    },
    title: {
      fontSize: 20,
      marginTop: 10,
      marginBottom: 10,
    },
    h3: {
      fontSize: 16,
    },
    small: {
      fontSize: 10,
    },
    bold: {
      fontWeight: 700,
    },
    info: {
      marginBottom: 10,
    },
    table: {
      display: 'table',
      width: 'auto',
      borderStyle: BORDER_STYLE,
      borderColor: BORDER_COLOR,
      borderWidth: 1,
      borderRightWidth: 0,
      borderBottomWidth: 0,
    },
    tableRow: {
      margin: 'auto',
      flexDirection: 'row',
    },
    tableColHeader: {
      borderStyle: BORDER_STYLE,
      borderColor: BORDER_COLOR,
      borderWidth: 1,
      borderLeftWidth: 0,
      borderTopWidth: 0,
      fontSize: 10,
    },
    tableCol: {
      borderStyle: BORDER_STYLE,
      borderColor: BORDER_COLOR,
      borderWidth: 1,
      borderLeftWidth: 0,
      borderTopWidth: 0,
    },
    tableCol1: {
      width: '15%',
    },
    tableCol2: {
      width: '20%',
    },
    tableCol3: {
      width: '65%',
    },
    tableCellHeader: {
      margin: 5,
      fontWeight: 700,
    },
    tableCell: {
      margin: 5,
      paddingTop: 5,
    },
    footer: {
      position: 'absolute',
      bottom: 30,
      left: 30,
    },
  });

  return (
    <Document>
      <Page size="A6" style={styles.body}>
        <Text style={styles.title}>
          {routeId ? `Route #${routeId} - ` : ''}
          {courierName}
        </Text>

        <View style={styles.info}>
          <Text>
            <Text style={styles.bold}>{copy.info.fruits}: </Text>
            <Text>{totalFruits}</Text>
          </Text>
          <Text>
            <Text style={styles.bold}>{copy.info.vegetables}: </Text>
            <Text>{totalVegs}</Text>
          </Text>
        </View>

        <View style={[styles.table, { marginBottom: 5 }]}>
          <View style={styles.tableRow}>
            <View style={[styles.tableColHeader, styles.tableCol1]}>
              <Text style={styles.tableCellHeader}>{copy.table.boxNumber}</Text>
            </View>
            <View style={[styles.tableColHeader, styles.tableCol2]}>
              <Text style={styles.tableCellHeader}>{copy.table.clientId}</Text>
            </View>
            <View style={[styles.tableColHeader, styles.tableCol3]}>
              <Text style={styles.tableCellHeader}>{copy.table.boxContent}</Text>
            </View>
          </View>
          {deliveryOrderBatches.map((orderBatch, index) => {
            const hasFreezer = orderBatch.orders.some((order) =>
              order.items.some((oi) => oi.item.temperature === ITEM_TEMPERATURE.freezer.name)
            );

            let fruitCount = 0;
            let vegCount = 0;

            orderBatch.orders.forEach((order) => {
              const fruits = order.items.filter((oi) => [898, 897].indexOf(oi.item.id) !== -1);
              const vegs = order.items.filter((oi) => [898, 896].indexOf(oi.item.id) !== -1);
              fruits.forEach((oi) => (fruitCount += oi.quantity));
              vegs.forEach((oi) => (vegCount += oi.quantity));
            });

            return (
              <View key={index} style={styles.tableRow}>
                <View style={[styles.tableCol, styles.tableCol1]}>
                  <Text style={styles.tableCell}></Text>
                </View>
                <View style={[styles.tableCol, styles.tableCol2]}>
                  <Text style={styles.tableCell}>
                    {orderBatch.packingId ? orderBatch.packingId : orderBatch.id ? `D${orderBatch.id}` : '_'}
                  </Text>
                </View>
                <View style={[styles.tableCol, styles.tableCol3]}>
                  <Text style={styles.tableCell}>
                    __ Bags{fruitCount > 0 ? ` + ${fruitCount} Fruits` : ''}
                    {vegCount > 0 ? ` + ${vegCount} Vegs` : ''}
                    {hasFreezer ? ' + Ice' : ''}
                  </Text>
                </View>
              </View>
            );
          })}
        </View>
      </Page>
    </Document>
  );
};

AdminDeliveryDayViewDeliveriesPdfDocument.propTypes = {
  deliveryOrderBatches: PropTypes.array.isRequired,
  courierName: PropTypes.string.isRequired,
  totalFruits: PropTypes.number.isRequired,
  totalVegs: PropTypes.number.isRequired,
  copy: PropTypes.object.isRequired,
};

AdminDeliveryDayViewDeliveriesPdfDocument.defaultProps = {};

export default AdminDeliveryDayViewDeliveriesPdfDocument;
